// Action types for the realtime Zalo-status slice. Dispatched by
// `useAccountShopStatusSubscription` in response to WS messages.
export const ZALO_STATUS_SNAPSHOT_RECEIVED = "ZALO_STATUS_SNAPSHOT_RECEIVED";
export const ZALO_STATUS_CHANGED = "ZALO_STATUS_CHANGED";
export const ZALO_STATUS_SUBSCRIPTION_CONNECTED =
  "ZALO_STATUS_SUBSCRIPTION_CONNECTED";
export const ZALO_STATUS_SUBSCRIPTION_DISCONNECTED =
  "ZALO_STATUS_SUBSCRIPTION_DISCONNECTED";
export const ZALO_STATUS_RESET = "ZALO_STATUS_RESET";

export const zaloStatusSnapshotReceived = (payload) => ({
  type: ZALO_STATUS_SNAPSHOT_RECEIVED,
  payload,
});

export const zaloStatusChanged = (payload) => ({
  type: ZALO_STATUS_CHANGED,
  payload,
});

export const zaloStatusSubscriptionConnected = (payload) => ({
  type: ZALO_STATUS_SUBSCRIPTION_CONNECTED,
  payload,
});

export const zaloStatusSubscriptionDisconnected = () => ({
  type: ZALO_STATUS_SUBSCRIPTION_DISCONNECTED,
});

export const zaloStatusReset = () => ({ type: ZALO_STATUS_RESET });
